export default __webpack_public_path__ + "src/appV2/lib/assets/images/holiday-gift/sweater.png";